import { ILlmConversationNode, LlmConversationNode, LlmForkMenuController, LlmForkSearchService, LlmForkService } from '@adaptiva/ai/common';
import { AdaLocalizedDatePipe } from '@adaptiva/core/common';
import { ErrorHandlerService } from '@adaptiva/core/error-handler';
import { MenuTriggerDirectiveModule } from '@adaptiva/core/menus';
import { UiService } from '@adaptiva/core/ui';
import { IconComponent } from '@adaptiva/widgets/icon';
import { MenuComponentModule } from '@adaptiva/widgets/menu';
import { SearchNavigationComponent } from '@adaptiva/widgets/search-navigation';
import { SearchTagComponentModule } from '@adaptiva/widgets/search-tag';
import { ChangeDetectionStrategy, Component, computed, inject, Signal } from '@angular/core';
import { BaseLlmTabComponent } from '../base-llm-tab';
import { LlmForkArtifactCountPipe } from './llm-fork-artifact-count.pipe';

@Component({
	selector: 'ada-llm-forks',
	templateUrl: './llm-forks.component.html',
	styleUrl: './llm-forks.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [
		AdaLocalizedDatePipe,
		IconComponent,
		LlmForkArtifactCountPipe,
		MenuComponentModule,
		MenuTriggerDirectiveModule,
		SearchNavigationComponent,
		SearchTagComponentModule,
	],
	providers: [
		LlmForkMenuController
	],
	host: {
		'[class.ada-display-block]': 'true',
		'[class.ada-full-size]': 'true',
	},
})
export class LlmForksComponent extends BaseLlmTabComponent {

	protected readonly forkService: LlmForkService = inject(LlmForkService);

	protected readonly ui: UiService = inject(UiService);

	protected readonly menuController: LlmForkMenuController = inject(LlmForkMenuController);

	protected readonly searchService: LlmForkSearchService = inject(LlmForkSearchService);

	protected readonly errorHandler: ErrorHandlerService = inject(ErrorHandlerService);

	protected activeIndex: Signal<int> = computed(() => {
		const _activeFork: LlmConversationNode = this.forkService.activeFork();
		const _visibleForks: LlmConversationNode[] = this.searchService.displayedForks();

		return _visibleForks.indexOf(_activeFork);
	});

	protected onForkClick(_fork: LlmConversationNode): void {
		this.forkService.changeFork({ conversationId: this.aida.conversationId(), forkName: _fork.forkName }).pipe(
			this.takeOneUntilDestroyed()
		).subscribe({
			next: (_activeNode: ILlmConversationNode) => {
				this.forkService.activeFork.set(_fork);
			},
			error: (e: Error) => {
				this.errorHandler.defaultErrorHandler(e, 'LlmForksComponent.onForkClick');
			}
		});
	}

	protected search(_event: string): void {
		this.searchService.search(_event);
	}

	protected close(): void {
		this.searchService.clear();
	}

	protected indexChange(_newIndex: int): void {
		if (this.searchService.currentQuery() === '')
			return;

		const _visibleForks: LlmConversationNode[] = this.searchService.displayedForks();
		const _newFork: LlmConversationNode = _visibleForks[_newIndex];

		if (!_newFork)
			return;

		this.forkService.activeFork.set(_newFork);
	}

}
